var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftSlideIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 57,
    height: 57,
    rx: 28.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.1382 16.0972C35.5767 16.5357 35.6166 17.222 35.2578 17.7056L35.1382 17.8441L24.4828 28.5001L35.1382 39.156C35.5767 39.5945 35.6166 40.2808 35.2578 40.7644L35.1382 40.903C34.6996 41.3415 34.0134 41.3814 33.5298 41.0226L33.3912 40.903L21.8618 29.3735C21.4233 28.935 21.3834 28.2487 21.7422 27.7651L21.8618 27.6266L33.3912 16.0972C33.8736 15.6147 34.6558 15.6147 35.1382 16.0972Z",
    fill: "#B9B5AB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftSlideIcon);
export default __webpack_public_path__ + "static/media/left-slide-icon.f07d627dfc1416a9c4a8855cbdf1091b.svg";
export { ForwardRef as ReactComponent };